import {Checkbox as MuiCheckbox, FormControlLabel, FormLabel, CheckboxProps} from '@mui/material';
import Text from 'components/labels/Text';
import React from 'react';
import ToggleField from '../ToggleField';

export interface MyCheckboxProps extends CheckboxProps{
  label?: string,
  labelPlacement?: any,
  simple?: boolean;
}

const Checkbox = (props: MyCheckboxProps) => {
  const {label, labelPlacement, simple, ...rest} = props
  if(simple)
    return <MuiCheckbox sx={{p: 0}} {...rest}  />
  return (
    <FormControlLabel sx={{ml: "-11px !important"}}  label={<FormLabel>{label}</FormLabel>} labelPlacement={labelPlacement} control={<MuiCheckbox  {...rest}  />}  />
  );
}
export default Checkbox;